<div class="text-center pt-5">
  <fgbcl-loading></fgbcl-loading>
  <p class="mt-2 mb-0 text-white"><em>Payment processing...</em></p>
</div>
